module.exports = __webpack_public_path__ + "static/13-3-791102cd907e0f14e5971089b624f576.jpg";